import { LocalStorageService } from './localStorage';
import { SessionStorageService } from './sessionStorage';

export class ConfigService {
  private static readonly TOKEN_KEY = 'token';
  private static readonly LANGUAGE_KEY = 'language';

  public static getToken() {
    return SessionStorageService.getItem(this.TOKEN_KEY);
  }

  public static setToken(token: string) {
    return SessionStorageService.setItem(this.TOKEN_KEY, token);
  }

  public static clearToken() {
    return SessionStorageService.removeItem(this.TOKEN_KEY);
  }

  public static getLanguage() {
    return LocalStorageService.getItem(this.LANGUAGE_KEY);
  }

  public static setLanguage(language: string) {
    return LocalStorageService.setItem(this.LANGUAGE_KEY, language);
  }
}